var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHammerLegal = function SvgHammerLegal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.654 13.394 8.652 9.393M12.393 5.651l4.001 4.002M3.996 22.004h10.59M4.896 22.004l.546-1.633a2 2 0 0 1 1.893-1.368h3.912a2 2 0 0 1 1.9 1.368l.542 1.633",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m9.89 8.298-2.2 1.756a1.836 1.836 0 0 0-.157 2.727l1.677 1.685a1.815 1.815 0 0 0 2.7-.143l1.778-2.207c.42-.523.896-.998 1.42-1.417l2.201-1.755a1.836 1.836 0 0 0 .156-2.728l-1.674-1.683a1.815 1.815 0 0 0-2.7.143l-1.78 2.207c-.42.522-.896.997-1.42 1.415Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.375 10.486 5.927 5.015a1.987 1.987 0 1 1-2.755 2.852l-5.237-5.766",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHammerLegal;